export const reviewCount = 343320
export const appleRating = 4.6
export const googleRating = 4.4
export const averageRating = 4.5
export const usersInMillions = 45
export const modified = '2020-10-23'
